import React, { useState } from "react";

function LosGatosFAQs() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const isActive = (index) => activeIndex === index;

  const faqs = [
    {
      question: "What types of junk do you remove in Los Gatos?",
      answer:
        "We handle a wide range of items including old furniture, appliances, construction debris, mattresses, yard waste, scrap metal, e-waste, and more. If it’s unwanted, we’ll take it!",
    },
    {
      question: "Do you offer same-day junk removal in Los Gatos?",
      answer:
        "Yes! We offer same-day junk removal for your convenience. If you need quick service, simply give us a call, and we’ll arrange to have your junk removed the very same day.",
    },
    {
      question: "What is your pricing for junk removal?",
      answer:
        "Our pricing is based on the volume of junk we remove. We offer transparent pricing with no hidden fees. We also provide a free estimate before we begin the job, so you’ll know exactly what to expect.",
    },

    {
      question: "How do I schedule junk removal services in Los Gatos?",
      answer:
        "Scheduling is easy! Just give us a call at (408) 539-7261 or fill out our online form for a free quote. We’ll confirm the details and arrange a time that works best for you.",
    },
    {
      question: "Are your junk removal services eco-friendly?",
      answer:
        "Absolutely! At Junk Droid, we are committed to eco-friendly disposal. We sort and recycle as much junk as possible to minimize our environmental impact. Responsible disposal is one of our top priorities.",
    },
    {
      question: "Can you remove hazardous materials?",
      answer:
        "We can remove certain hazardous materials like paints and chemicals. However, we follow all local regulations, and some items may need to be handled by specialized disposal services. Feel free to ask about specific materials when you schedule your junk removal.",
    },
    {
      question: "How do I prepare for a junk removal appointment?",
      answer:
        "Simply gather your unwanted items in one location, and we’ll do the rest! If you have any special instructions or large items like furniture or appliances, just let us know when you book your appointment.",
    },
    {
      question:
        "Do you offer junk removal for commercial properties in Los Gatos?",
      answer:
        "Yes, we provide commercial junk removal services in Los Gatos. Whether you need to clear out office furniture, construction debris, or other items, we’ve got the experience to handle jobs of any size.",
    },
    {
      question: "Do you accept credit cards for payment?",
      answer:
        "Yes, we accept all major credit cards for your convenience. You can pay easily and securely after your junk has been removed.",
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion junk-faq-sec">
          {faqs.map((faq, index) => (
            <div
              className={`accordion-item ${isActive(index) ? "active" : ""}`}
              key={index}
            >
              <div
                className="accordion-item-header"
                onClick={() => handleAccordionClick(index)}
                style={{ color: isActive(index) ? "blue" : "#000" }}
              >
                <span className="accordion-item-header-title">
                  <img
                    src={
                      isActive(index)
                        ? "/assets/img/question-mark-yellow.svg"
                        : "/assets/img/_Compound Path_.png"
                    }
                    alt="default"
                    loading="lazy"
                    className="accordion-image"
                  />
                  <p>{faq.question}</p>
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                    style={{ color: isActive(index) ? "#2d6bd6" : "#000" }}
                  />
                </svg>
              </div>
              <div
                className={`accordion-item-description-wrapper ${
                  isActive(index) ? "open" : ""
                }`}
                style={{ display: isActive(index) ? "block" : "none" }}
              >
                <div className="accordion-item-description">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default LosGatosFAQs;
